import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function SettingsPage() {
    const { user } = useAuth();
    return (
        <div data-testid="settings-page">
            <div className="mb-10">
                <div className="label-eyebrow mb-2">Account</div>
                <h1 className="font-display text-4xl text-navy">
                    Impostazioni
                </h1>
            </div>

            <div className="grid md:grid-cols-2 gap-5">
                <div
                    className="bg-white border border-sf rounded-xl p-6"
                    data-testid="settings-profile"
                >
                    <div className="label-eyebrow mb-3">Profilo</div>
                    <div className="space-y-2 text-sm">
                        <Row label="Nome" value={user?.name} />
                        <Row label="Email" value={user?.email} />
                        <Row label="Locale" value={user?.company_name || "—"} />
                        <Row
                            label="Ruolo"
                            value={user?.role === "admin" ? "Admin" : "Manager"}
                        />
                    </div>
                </div>

                <div
                    className="bg-white border border-sf rounded-xl p-6"
                    data-testid="settings-billing"
                >
                    <div className="label-eyebrow mb-3">Abbonamento</div>
                    <div className="font-display text-3xl text-navy capitalize mb-2">
                        {user?.subscription_tier === "free"
                            ? "Trial"
                            : user?.subscription_tier}
                    </div>
                    <div className="text-sm text-sf-secondary mb-4">
                        Stato:{" "}
                        <span
                            className={
                                user?.subscription_status === "active"
                                    ? "text-green-700 font-semibold"
                                    : "text-amber-brand font-semibold"
                            }
                        >
                            {user?.subscription_status === "active"
                                ? "Attivo"
                                : "Non attivo"}
                        </span>
                        {user?.subscription_until && (
                            <span className="text-sf-muted ml-2">
                                ·{" "}
                                {new Date(
                                    user.subscription_until
                                ).toLocaleDateString("it-IT")}
                            </span>
                        )}
                    </div>
                    <Link to="/pricing">
                        <Button
                            className="bg-navy text-white"
                            data-testid="settings-manage-plan"
                        >
                            {user?.subscription_status === "active"
                                ? "Cambia piano"
                                : "Scegli un piano"}
                        </Button>
                    </Link>
                </div>

                <div
                    className="bg-white border border-sf rounded-xl p-6 md:col-span-2"
                    data-testid="settings-billing-info"
                >
                    <div className="flex items-center justify-between gap-3">
                        <div>
                            <div className="label-eyebrow mb-2">
                                Dati di fatturazione
                            </div>
                            <div className="font-display text-2xl text-navy mb-1">
                                {user?.has_billing_info
                                    ? "Dati inseriti ✓"
                                    : "Dati mancanti"}
                            </div>
                            <p className="text-sm text-sf-secondary max-w-xl">
                                {user?.has_billing_info
                                    ? "Puoi sottoscrivere o cambiare piano in qualsiasi momento."
                                    : "Per attivare un abbonamento (Base €9 o Pro €19) inserisci prima i dati di fatturazione (ragione sociale, P.IVA/CF, indirizzo, PEC/SDI, contatti)."}
                            </p>
                        </div>
                        <Link
                            to="/billing/info"
                            state={{ next: "/app/impostazioni" }}
                        >
                            <Button
                                variant={
                                    user?.has_billing_info
                                        ? "outline"
                                        : "default"
                                }
                                className={
                                    user?.has_billing_info
                                        ? ""
                                        : "bg-amber-brand text-navy hover:bg-amber-brand/90 font-bold"
                                }
                                data-testid="settings-edit-billing"
                            >
                                {user?.has_billing_info
                                    ? "Modifica"
                                    : "Inserisci"}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="mt-10 text-xs text-sf-muted">
                Staff Flow 360 è un prodotto di Makai · P.IVA 09364410969
            </div>
        </div>
    );
}

function Row({ label, value }) {
    return (
        <div className="flex justify-between border-b border-sf py-2">
            <span className="text-sf-muted">{label}</span>
            <span className="font-medium text-navy">{value}</span>
        </div>
    );
}
